// extracted by mini-css-extract-plugin
export default {"productGallery":"zJ-z","inQuickShop":"AJ-z"};